import _ from "../constants/Translations";

export const TRANSLATION_UPDATE = "TRANSLATION_UPDATE";

export const updateTranslation = (lang) => {
  return {
    type: TRANSLATION_UPDATE,
    payload: {
      ..._(lang),
    },
  };
};
